import {ApprovalStatusType} from "../enums/approval-status-type.enum";

export class RecruitToHireProcess {
  step: number;
  status: boolean;
  approvalStatus?: ApprovalStatusType;
  stepDescription: string;
  person?: string;
  link?: string;
}